export enum LogicalSearchOperatorEnums {
    And = 1,
    Or = 2
  }
  
  export enum SearchGroupingType {
    Distinct = 'DISTINCT',
    Aggregate = 'AGGREGATE'
  }
  
  
  export enum SearchSortDirection {
    Asc = 'ASC',
    Desc = 'DESC'
  }
  